import React from "react";

interface DateChangeProps {
    selectedDate: string;
    setSelectedDate: React.Dispatch<React.SetStateAction<string>>;
    chartType: 'daily' | 'weekly' | 'monthly';
    setChartType: React.Dispatch<React.SetStateAction<'daily' | 'weekly' | 'monthly'>>;
    handleDateChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const DateChange: React.FC<DateChangeProps> = ({ selectedDate, setSelectedDate, chartType, setChartType, handleDateChange }) => {

    return (
        <div className="px-4 pb-4">
            <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3">
                {/* 날짜 선택 입력 */}
                <div className="position-relative">
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        className="form-control shadow-sm border-light rounded-pill px-4"
                        style={{ 
                            maxWidth: '220px',
                            height: '42px',
                            fontSize: '14px',
                            backgroundColor: '#f8fafc'
                        }}
                    />
                </div>

                {/* 차트 타입 버튼 그룹 */}
                <div className="btn-group shadow-sm rounded-pill overflow-hidden" role="group">
                    {(['daily', 'weekly', 'monthly'] as const).map((type) => (
                        <button
                            key={type}
                            type="button"
                            className={`btn position-relative border-0 ${
                                chartType === type 
                                ? 'btn-primary text-white' 
                                : 'btn-white text-muted hover-bg-light'
                            }`}
                            style={{ 
                                minWidth: '70px',
                                fontSize: '14px',
                                fontWeight: chartType === type ? '600' : '400',
                                height: '42px',
                                borderRadius: 0
                            }}
                            onClick={() => setChartType(type)}
                        >
                            {type === 'daily' ? '일간' : type === 'weekly' ? '주간' : '월간'}
                            {chartType === type && (
                                <span className="position-absolute bottom-0 start-50 translate-middle-x mb-1 rounded-circle bg-white" style={{ width: '4px', height: '4px' }}></span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DateChange;
